import { Reptile } from '../../types/Reptile.ts';
export const MorphOrSpecies = ({ reptile, isSpecies, plural }: { reptile?: Reptile, isSpecies?: boolean, plural?: boolean }) => {
    return isSpecies || (reptile && reptile.controls && reptile.controls.isSpecies) ? "Species" : `Morph${plural ? "s" : ""}`;
}